import { graphql, useStaticQuery } from "gatsby"
import React, { useState } from "react"

import Post from "../vignettes/Post"

export default function PostsList({ locale }) {
  const [currentRefinement, setCurrentRefinement] = useState("all")
  const {
    wpPosts_fr,
    wpPosts_en,
    wpCategory_fr,
    wpCategory_en,
  } = useStaticQuery(graphql`
    query BlogListQueryFr {
      wpPosts_fr: allWpPost(
        filter: { language: { locale: { eq: "fr_FR" } } }
        sort: { modified: DESC }
      ) {
        nodes {
          ...PostGeneralFragment
        }
      }
      wpPosts_en: allWpPost(
        filter: { language: { locale: { eq: "en_GB" } } }
        sort: { modified: DESC }
      ) {
        nodes {
          ...PostGeneralFragment
        }
      }
      wpCategory_fr: allWpCategory(
        filter: { language: { locale: { eq: "fr_FR" } } }
        sort: { name: DESC }
      ) {
        nodes {
          name
          slug
        }
      }
      wpCategory_en: allWpCategory(
        filter: { language: { locale: { eq: "en_EN" } } }
        sort: { name: ASC }
      ) {
        nodes {
          name
          slug
        }
      }
    }
  `)
  const wpposts = locale === "fr_FR" ? wpPosts_fr.nodes : wpPosts_en.nodes
  const categories =
    locale === "fr_FR" ? wpCategory_fr.nodes : wpCategory_en.nodes

  const isActive = slug => currentRefinement === slug

  const filteredWpPosts =
    currentRefinement !== "all"
      ? wpposts.filter(p =>
          p.categories.nodes.flatMap(c => c.slug).includes(currentRefinement)
        )
      : wpposts

  return (
    <>
      <div className="relative">
        <div className="max-w-7xl px-4 mx-auto sm:px-8 flex  flex-wrap	gap-2 mt-8">
          <button
            key="all"
            type="button"
            className={`
            block px-2 py-1 text-xs font-semibold tracking-wide text-white uppercase rounded bg-blue-600 
            ${isActive("all") ? "bg-orangeSafe" : ""}
            `}
            onClick={() => setCurrentRefinement("all")}
          >
            Tout
          </button>
          {categories
            .filter(c => c.slug !== "uncategorized")
            .map(c => (
              <button
                key={c.slug}
                className={`block px-2 py-1 text-xs font-semibold tracking-wide text-white uppercase rounded  
               bg-blue-600 ${isActive(c.slug) ? "bg-orangeSafe" : ""}`}
                type="button"
                onClick={() => setCurrentRefinement(c.slug)}
              >
                {c.name}
              </button>
            ))}
        </div>
      </div>
      <div className="bg-charlestonGreen-100">
        <div className="relative">
          <div className="max-w-7xl px-4 pt-12 pb-16 mx-auto sm:px-8 sm:pb-24 mt-8">
            <div className="relative grid max-w-lg gap-5 mx-auto lg:grid-cols-3 lg:max-w-none">
              {filteredWpPosts.map(post => (
                <Post key={post.uri} post={post} locale={locale} />
              ))}
              {filteredWpPosts.length === 0 &&
                "Aucun résultat pour cette catégorie"}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
